import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollReveal from '@/components/base/ScrollReveal';
import CountUp from '@/components/base/CountUp';
import ParticleBackground from '@/components/base/ParticleBackground';

const positions = [
  { icon: 'ri-edit-line', title: 'AI编剧', desc: '运用AI工具进行剧本创作、故事策划与内容构思，产出高质量漫剧/短剧剧本。' },
  { icon: 'ri-brush-line', title: 'AI绘画设计师', desc: '使用AI绘画工具进行角色设计、场景绘制与视觉风格把控。' },
  { icon: 'ri-film-line', title: '短视频剪辑', desc: '负责AI漫剧/短剧的后期剪辑、特效制作与成片输出。' },
  { icon: 'ri-voiceprint-line', title: '配音制作', desc: '负责AI内容的智能配音、音效设计与音频后期处理。' },
  { icon: 'ri-user-star-line', title: '账号运营', desc: '负责各内容平台的账号运营、数据分析与粉丝增长。' },
  { icon: 'ri-translate-2', title: '跨境内容译制', desc: '负责文化内容的海外多语种翻译与本土化适配。' },
  { icon: 'ri-service-line', title: '商务招商', desc: '负责品牌合作洽谈、渠道拓展与商务关系维护。' },
  { icon: 'ri-projector-line', title: '项目运营', desc: '统筹项目执行、资源协调与交付管理。' },
  { icon: 'ri-building-line', title: '校企合作专员', desc: '负责高校合作对接、实训基地运营与人才招募。' },
];

const model = [
  { icon: 'ri-book-open-line', title: '课程', desc: '系统化岗前培训课程' },
  { icon: 'ri-tools-line', title: '实训', desc: '真实项目实战训练' },
  { icon: 'ri-rocket-line', title: '项目', desc: '参与商业项目孵化' },
  { icon: 'ri-briefcase-line', title: '就业', desc: '直通企业岗位就业' },
  { icon: 'ri-seedling-line', title: '创业', desc: '提供创业孵化扶持' },
];

const cooperationItems = [
  '课程共建', '实训基地', '项目孵化', '就业输送', '创业扶持', '赛事合作', 'OPC人才协同',
];

export default function Education() {
  return (
    <div className="ui-page">
      <Navbar />
      <main className="pt-20">
        <section className="relative py-20 md:py-28 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-background-900/40 to-transparent z-[1]"></div>
          <ParticleBackground compact />
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
            <div className="max-w-screen-2xl mx-auto">
              <ScrollReveal>
                <div className="text-center mb-16">
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-6">
                    <span className="w-1 h-1 rounded-full bg-primary-500"></span>
                    <span className="text-primary-300 text-xs font-medium tracking-wider whitespace-nowrap">Education</span>
                  </div>
                  <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-primary-500 mb-6">产教融合</h1>
                  <p className="text-secondary-400 text-lg max-w-2xl mx-auto">AI漫剧人才孵化基地 · 五位一体培养模式 · OPC人才协同</p>
                </div>
              </ScrollReveal>

              {/* Stats */}
              <ScrollReveal>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
                  {[
                    { value: 5, suffix: '', label: '五位一体模式' },
                    { value: 9, suffix: '', label: '岗位方向覆盖' },
                    { value: 6, suffix: '', label: '校企合作内容' },
                    { value: 100, suffix: '+', label: '预计年培养人才' },
                  ].map((stat) => (
                    <div key={stat.label} className="group bg-background-900/50 rounded-2xl border border-primary-500/10 p-6 text-center hover:border-primary-500/25 hover:-translate-y-2 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.12)]">
                      <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500 mb-2">
                        <CountUp end={stat.value} duration={2000} suffix={stat.suffix} />
                      </div>
                      <p className="text-secondary-400 text-xs md:text-sm">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </ScrollReveal>

              <ScrollReveal>
                <div className="group bg-background-900/50 rounded-2xl border border-primary-500/15 p-8 md:p-12 mb-16 hover:border-primary-500/25 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.1)]">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                    <div>
                      <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-6 group-hover:text-primary-500 transition-colors duration-500">AI漫剧人才孵化基地</h2>
                      <p className="text-secondary-300 text-sm leading-relaxed mb-4">
                        晋铧叙梦打造<strong className="text-foreground-100 font-medium">人才培养、项目孵化、内容量产、IP全链路运营</strong>一体化平台，以"五位一体"模式实现课程、实训、项目、就业、创业的完整闭环。
                      </p>
                      <p className="text-secondary-300 text-sm leading-relaxed">
                        岗位覆盖<strong className="text-primary-500 font-semibold">AI编剧、AI绘画、分镜、剪辑、配音、账号运营、跨境译制</strong>等全产业链环节，为学员提供从技能培训到就业创业的全流程支持。
                      </p>
                    </div>
                    <div className="relative rounded-2xl overflow-hidden border border-primary-500/10 group/img">
                      <img
                        src="https://readdy.ai/api/search-image?query=Modern%20digital%20media%20training%20center%20with%20Chinese%20cultural%20elements%2C%20students%20working%20on%20AI%20creative%20projects%2C%20professional%20studio%20environment%2C%20warm%20golden%20lighting%2C%20dark%20modern%20interior%2C%20no%20text&width=600&height=400&seq=education-campus-13&orientation=landscape"
                        alt="AI漫剧人才孵化基地"
                        className="w-full h-auto object-cover transition-transform duration-700 group-hover/img:scale-105"
                      />
                    </div>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-10 text-center">五位一体培养模式</h2>
              </ScrollReveal>
              <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-16">
                {model.map((item) => (
                  <ScrollReveal key={item.title}>
                    <div className="group bg-background-900/50 rounded-2xl border border-primary-500/10 p-6 text-center hover:border-primary-500/25 hover:-translate-y-2 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.12)] h-full">
                      <div className="w-12 h-12 mx-auto rounded-full bg-primary-500/10 flex items-center justify-center mb-4 group-hover:bg-primary-500/20 group-hover:scale-110 transition-all duration-500">
                        <i className={`${item.icon} text-primary-500 text-xl`}></i>
                      </div>
                      <h4 className="text-foreground-50 font-semibold text-sm mb-2 group-hover:text-primary-500 transition-colors duration-500">{item.title}</h4>
                      <p className="text-secondary-500 text-xs">{item.desc}</p>
                    </div>
                  </ScrollReveal>
                ))}
              </div>

              <ScrollReveal>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-10 text-center">岗位方向</h2>
              </ScrollReveal>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-16">
                {positions.map((item) => (
                  <ScrollReveal key={item.title}>
                    <div className="group flex items-start gap-4 bg-background-900/50 rounded-xl border border-primary-500/10 p-5 hover:border-primary-500/25 hover:-translate-y-1 transition-all duration-500 hover:shadow-[0_0_20px_rgba(180,140,80,0.1)]">
                      <div className="w-10 h-10 rounded-lg bg-accent-500/10 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-500/20 group-hover:scale-110 transition-all duration-500">
                        <i className={`${item.icon} text-accent-500`}></i>
                      </div>
                      <div>
                        <h4 className="text-foreground-50 font-medium text-sm mb-1 group-hover:text-accent-400 transition-colors duration-300">{item.title}</h4>
                        <p className="text-secondary-500 text-xs leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                  </ScrollReveal>
                ))}
              </div>

              <ScrollReveal>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-10 text-center">校企合作内容</h2>
              </ScrollReveal>
              <div className="flex flex-wrap justify-center gap-3 mb-10">
                {cooperationItems.map((item) => (
                  <span key={item} className="px-5 py-2.5 rounded-full bg-secondary-500/10 border border-secondary-500/15 text-secondary-300 text-sm whitespace-nowrap hover:bg-secondary-500/20 hover:text-secondary-200 hover:border-secondary-500/30 transition-all duration-300 cursor-default">
                    {item}
                  </span>
                ))}
              </div>

              <ScrollReveal>
                <div className="text-center">
                  <p className="text-secondary-400 text-sm max-w-3xl mx-auto mb-6">
                    依托冯全普·县域AI+OPC联盟人才培养体系，为高校学生与青年人才提供从AI技能训练、项目实战到创业孵化的完整成长路径。
                  </p>
                  <a href="/recruit" className="group/btn inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-foreground-50 font-medium rounded-full text-sm hover:bg-accent-400 transition-all duration-300 whitespace-nowrap cursor-pointer">
                    查看招聘岗位
                    <div className="w-4 h-4 flex items-center justify-center transition-transform duration-300 group-hover/btn:translate-x-1">
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </a>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
